import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';
import { UITabModel } from 'e5core-angular-services';

@Component({
  selector: 'e5core-ui-work-tab-set-material',
  templateUrl: './e5core-ui-work-tab-set-material.component.html',
  styleUrls: ['./e5core-ui-work-tab-set-material.component.css']
})
export class E5coreUiWorkTabSetMaterialComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() tabs: UITabModel[] ;

  constructor() { }

  ngOnInit() {
  }

}
